import { render } from "./TestSubjects.vue?vue&type=template&id=5ff1e32e"
import script from "./TestSubjects.vue?vue&type=script&lang=js"
export * from "./TestSubjects.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__